import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import isEmpty from 'lodash/isEmpty';

import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { DateField, CheckboxField, SelectField } from 'jbc-front/components/Form';
import { FormSubmitBtn } from 'src/buttons';
import { CONFIRM_CLIENT_BONUS } from 'src/constants/FormNames';
import { formatDate } from 'src/utils/Date';
import { ErrorsSection, LoadingWithDescription } from 'src/components';
import { get24HoursOptions } from 'src/utils/Form';
import { getChangeConfirmBonusErrors } from 'src/reducers/clients/clientBonus';
import { takeBonusFromSearchForm } from 'src/reducers/searchForm';
import { isYYYYMMDDFormat } from 'src/utils/CustomValidators';
import styles from './ConfirmBonusModal.scss';
import { useTranslation } from 'react-i18next';

const DEFAULT_RELEASE_HOUR = '9';

const genInitialValue = selectedClientBonus => {
  const { payOn } = selectedClientBonus || {};
  if (isEmpty(payOn)) {
    return {};
  }
  return { releaseDate: payOn, releaseHour: DEFAULT_RELEASE_HOUR };
};

const ConfirmBonusInsideForm = ({ submitting, submit, cancelBtnClick, selectedClientBonus, errors, header }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form>
          <div className={styles.body}>
            <ErrorsSection errors={errors} title={t('features.EmployeeBonus.components.ConfirmBonusModal.Setting_is_incorrect')} />
            {submitting && (
              <div className="u-mb20">
                <LoadingWithDescription text={t('features.EmployeeBonus.components.ConfirmBonusModal.Confirming_Please_wait')} />
              </div>
            )}
            <div>
              {t('features.EmployeeBonus.components.ConfirmBonusModal.Confirm_bonus')}<br />
              ({t('features.EmployeeBonus.components.ConfirmBonusModal.payment_date')} : {formatDate(selectedClientBonus.payOn)})
              <br />
              <br />
            </div>
            <DateField required name="releaseDate" label={t('features.EmployeeBonus.components.ConfirmBonusModal.Payslip_disclosure_time_to_employee')} validate={isYYYYMMDDFormat} />
            <div style={{ width: '120px' }}>
              <SelectField required label="" name="releaseHour" options={get24HoursOptions()} width={100} />
            </div>
            <div>
              <CheckboxField name="send_notify_to_employee" label={t('features.EmployeeBonus.components.ConfirmBonusModal.Send_notification_email_at_the_same_time_as_payslip_disclosure')} />
            </div>
          </div>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.EmployeeBonus.components.ConfirmBonusModal.Cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeeBonus.components.ConfirmBonusModal.Confirm')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let ConfirmBonusForm = reduxForm({
  form: CONFIRM_CLIENT_BONUS
})(ConfirmBonusInsideForm);
const mapStateToProp = (state, ownProps) => ({
  initialValues: genInitialValue(ownProps.selectedClientBonus),
  errors: getChangeConfirmBonusErrors(state)
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  onSubmit: data => ownProps.confirmClientBonus(ownProps.selectedClientBonus.value, data, ownProps.cancelBtnClick)
});

ConfirmBonusForm = connect(mapStateToProp, mapDispatchToProp)(ConfirmBonusForm);

const ConfirmBonusModal = ({ isOpen, hideModal, confirmClientBonus, selectedClientBonus }) => {
  const { t } = useTranslation();
  const header = t('features.EmployeeBonus.components.ConfirmBonusModal.Bonus_confirmation');
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <ConfirmBonusForm cancelBtnClick={hideModal} {...{ confirmClientBonus, selectedClientBonus }} header={header} />
    </CommonModal>
  );
};

const mapStateToProps = state => ({
  selectedClientBonus: takeBonusFromSearchForm(state)
});
export default connect(mapStateToProps)(ConfirmBonusModal);
